import React, { useEffect, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import { useMarks } from '../../../DataStore/MarksContext';

const MarksCopier = () => {
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);

  const [source, setSource] = useState({});
  const [destination, setDestination] = useState({});
  const {setCopyMarks} = useMarks();

  const {
    classes,
    academicTerms,
    assessmentList,
    getClasses,
    getAcademicTerms,
    getAssessments,
  } = useConfig();

  useEffect(() => {
    getClasses();
    getAcademicTerms();
    getAssessments();
  }, []);

  const handleChange = (type, name, value) => {
    const update = type === 'source' ? { ...source } : { ...destination };
    update[name] = value;
    type === 'source' ? setSource(update) : setDestination(update);
  };

  const mapOptions = (data, labelFn, valueKey) =>
    Array.isArray(data) ? data.map((item) => ({ label: labelFn(item), value: item[valueKey] })) : [];

  const renderSelect = (label, options, value, onChange) => (
    <TextInput
      label={label}
      type="select"
      options={options}
      onChange={onChange}
      value={value}
      placeholder={`Select ${label.toLowerCase()}...`}
      wrap
      required
    />
  );

  const renderText = (label, value, onChange) => (
    <TextInput
      label={label}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={`Enter ${label.toLowerCase()}...`}
      wrap
      required
    />
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const required = [
      source.class_id, source.exam_id, source.term_id, source.academic_year,
      destination.class_id, destination.exam_id, destination.term_id, destination.academic_year,
    ];

    if (required.some(val => !val || (val.value !== undefined && !val.value))) {
      setNotify(<Notification type="danger" message="Please complete all fields, then try again." />);
      return;
    }

    const payload = {
      source_class_id: source.class_id.value,
      source_exam_id: source.exam_id.value,
      source_term_id: source.term_id.value,
      source_academic_year: source.academic_year,
      dest_class_id: destination.class_id.value,
      dest_exam_id: destination.exam_id.value,
      dest_term_id: destination.term_id.value,
      dest_academic_year: destination.academic_year,
    };

    setNotify(null);
    setCopyMarks({ show: true, data: payload, callback: () => {} });
  };

  return (
    <div className="card-body">
      <CallOut
        title="Copy Marks"
        description="Copy exam marks from a previous academic period to a new one."
      />
      {notify}

      <form className="form-horizontal" onSubmit={handleSubmit}>
  <div className="marks-grid mb-4">
    <div className="marks-cell">
      <div className="text-primary section-title">Marks Source</div>
    </div>
    <div className="marks-cell">
      <div className="text-success section-title">Marks Destination</div>
    </div>

    <div className="marks-cell">
      {renderSelect('Class', mapOptions(classes, i => i.class_name, 'class_id'), source.class_id, item => handleChange('source', 'class_id', item))}
    </div>
    <div className="marks-cell">
      {renderSelect('Class', mapOptions(classes, i => i.class_name, 'class_id'), destination.class_id, item => handleChange('destination', 'class_id', item))}
    </div>

    <div className="marks-cell">
      {renderSelect('Exam', mapOptions(assessmentList, i => i.exam_name, 'id'), source.exam_id, item => handleChange('source', 'exam_id', item))}
    </div>
    <div className="marks-cell">
      {renderSelect('Exam', mapOptions(assessmentList, i => i.exam_name, 'id'), destination.exam_id, item => handleChange('destination', 'exam_id', item))}
    </div>

    <div className="marks-cell">
      {renderSelect('Term', mapOptions(academicTerms, i => i.term, 'term_id'), source.term_id, item => handleChange('source', 'term_id', item))}
    </div>
    <div className="marks-cell">
      {renderSelect('Term', mapOptions(academicTerms, i => i.term, 'term_id'), destination.term_id, item => handleChange('destination', 'term_id', item))}
    </div>

    <div className="marks-cell">
      {renderText('Academic Year', source.academic_year || '', val => handleChange('source', 'academic_year', val))}
    </div>
    <div className="marks-cell">
      {renderText('Academic Year', destination.academic_year || '', val => handleChange('destination', 'academic_year', val))}
    </div>
  </div>

  <div className="text-right">
    {!loading ? (
      <button type="submit" className="btn btn-lg btn-primary">
        Copy Marks
      </button>
    ) : (
      <ActivityLoader />
    )}
  </div>
</form>

    </div>
  );
};

export default MarksCopier;
